"use client"
import { Button } from "@/components/ui/button"
import { useRouter } from "next/navigation"

const NotFound = () => {
  const router = useRouter()

  return (
    <div className="flex flex-col h-screen items-center justify-center text-center">
      <div className="container max-w-md">
        <h1 className="text-4xl font-bold mb-4">
          Oops!!!
        </h1>
        <p className="text-xl mb-4">
          This page you are looking for could not be found.
        </p>
        <Button onClick={() => router.push("/")}>
          Go Back to Home
        </Button>
      </div>
    </div>
  )
}

export default NotFound
